<template>
  <b-container>
  <div style="margin: 1rem 0 0 0;">

    <b-row>
      <b-col sm="6">
        <div @click="downloaded_file">
          <a download="info.txt" id="downloadlink" style="display: none">
             Click To Download File
          </a>
        </div>
        <b-button v-if="!saveFile" size="sm"
          :disabled="!enableSave()"
          :variant="enableSave()?'primary':'secondary'"
          @click="make_save_file">
          Save
        </b-button>
        <b-input v-if="!saveFile"
         style="width:auto;display:inline-block;max-width:60%"
         placeholder="Save CSV Filename"
         v-model="saveFileName"
         >
        </b-input>
      </b-col>
      <b-col sm="6">
        <b-button v-if="!saveFile" size="sm"
          :disabled="!loadFile"
          :variant="loadFile?'primary':'secondary'"
          @click="load_from_file">
          Load
        </b-button>
        <b-form-file v-if="!saveFile"
           style="width:auto;display:inline-block;max-width:60%"
           placeholder="Load CSV Filename"
           drop-placeholder="-"
           browse-text="-"
           v-model="loadFile" size="sm"
           :state="Boolean(loadFile)">
        </b-form-file>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="6">
        <b-button size="sm"
          v-if=""
          :disabled="!input.email"
          :variant='input.email?"primary":"secondary"'
          @click="addPresenter">
          Add
        </b-button>
        <b-input
          v-if=""
          style="width:auto;display:inline-block;"
          placeholder="Email of Presenter to Add"
          v-on:keyup='addPresenterKP'
          v-model="input.email">
        </b-input>
      </b-col>
      <b-col sm="6">
        <b-button variant="primary" size="sm"
          @click="refreshAll">
          Refresh
        </b-button>
        <b-input
          v-if=""
          style="width:auto;display:inline-block"
          placeholder="Search Participants"
          v-on:keyup='searchPartKP'
          v-model="filt.name">
        </b-input>
      </b-col>
    </b-row>

    <b-row style="border-top: 2px solid; padding: 0.5rem 0;">
    </b-row>
    <b-row>
      <b-col md="2">
        Layout
      </b-col>
      <b-col md="1"  v-if="pres_cnt <= 2" class="btn_layout">
        <b-button size="sm"
          :variant='(selected_layout == "2x1p5")?"warning":"outline-secondary"'
          style="width:100%;"
          @click='select_layout("2x1p5")'>
          1x2
        </b-button>
      </b-col>
      <b-col md="1" v-if="pres_cnt <= 4" class="btn_layout">
        <b-button size="sm"
          :variant='(selected_layout == "2x2p5")?"warning":"outline-secondary"'
          style="width:100%;"
          @click='select_layout("2x2p5")'>
          2x2
        </b-button>
      </b-col>
      <b-col md="1" class="btn_layout">
        <b-button size="sm"
          :variant='(selected_layout == "3x2p5")?"warning":"outline-secondary"'
          style="width:100%;"
          @click='select_layout("3x2p5")'>
          3x2
        </b-button>
      </b-col>
      <b-col md="1" class="btn_layout">
        <b-button size="sm"
          :variant='(selected_layout == "3x3p5")?"warning":"outline-secondary"'
          style="width:100%;"
          @click='select_layout("3x3p5")'>
          3x3
        </b-button>
      </b-col>
      <b-col md="2" class="btn_layout">
        <b-button size="sm"
          :variant='(selected_layout == "1on4")?"warning":"outline-secondary"'
          style="width:100%;"
          @click='select_layout("1on4")'>
          1 Big+4
        </b-button>
      </b-col>
      <b-col md="2" class="btn_layout">
        <b-button size="sm"
          :variant='(selected_layout == "2on4")?"warning":"outline-secondary"'
          style="width:100%;"
          @click='select_layout("2on4")'>
          2 Big+4
        </b-button>
      </b-col>
    </b-row>
    <b-row style="border-top: 2px solid; padding: 0.5rem 0;">
    </b-row>

    <b-row>
      <b-col md="2">
        Who can be Seen
      </b-col>
      <b-col md="2">
        <b-button size="sm"
          :variant='(prsonly)?"warning":"outline-secondary"'
          style="width:100%;"
          @click='select_prsonly(true)'>
          Hosts
        </b-button>
      </b-col>
      <b-col md="2">
        <b-button size="sm"
          :variant='(!prsonly)?"warning":"outline-secondary"'
          style="width:100%;"
          @click='select_prsonly(false)'>
          Everyone
        </b-button>
      </b-col>
    </b-row>
    <b-row style="border-top: 2px solid; padding: 0.5rem 0;">
    </b-row>

    <b-row>
      <b-col md="2">
        Who can Speak
      </b-col>
      <b-col md="2">
        <b-button size="sm"
          :variant='(selected_ac == 0)?"warning":"outline-secondary"'
          style="width:100%;"
          @click='select_ac(0)'>
          Hosts
        </b-button>
      </b-col>
      <b-col md="2">
        <b-button size="sm"
          :variant='(selected_ac == 1)?"warning":"outline-secondary"'
          style="width:100%;"
          :disabled="prsonly"
          @click='select_ac(1)'>
          Hosts+Q&A
        </b-button>
      </b-col>
    </b-row>
    <b-row style="border-top: 2px solid; padding: 0.5rem 0;">
    </b-row>

    <b-row>
        People in the Room ({{ qna_cnt }} Hands Raised{{filtered?(", searching:"+filt.name):""}})
        <b-table striped show-empty stacked="md"
         :fields="qnaFields"
         :items="qna"
         empty-text="No one is in the room."
         small>
          <template v-slot:cell(pin)="data">
            <b-button style="margin:0;margin-right:0.3rem;padding:0.3rem;"
                 :variant="data.item.pinned?'vxon':'outline-secondary'"
                 @click="toggle_pin(data.item)">
            </b-button>
          </template>
          <template v-slot:cell(pos)="data">
            {{ data.item.pos }}
          </template>
          <template v-slot:cell(visible)="data">
            <b-button v-if="data.item.present"
              class="btn_ctrl" size="sm"
              style="margin-right:0rem;cursor:default;"
              :variant='(data.item.audible)?"vxgreen":"outline-secondary"'>
              AUDIBLE
            </b-button>
            <b-button v-if="data.item.present"
              class="btn_ctrl" size="sm"
              style="margin-right:1rem;cursor:default;"
              :variant='(data.item.visible)?"vxgreen":"outline-secondary"'>
              VISIBLE
            </b-button>
            <b-button  v-if="data.item.present && data.item.self_muted"
              class="btn_ctrl" size="sm"
              disabled
              style="margin-right:1rem;cursor:not-allowed"
              variant="outline-danger">
              MUTED
            </b-button>
            <b-button  v-if="data.item.present && !data.item.self_muted"
              class="btn_ctrl" size="sm"
              style="margin-right:1rem"
              :variant='(!data.item.muted)?"warning":"outline-secondary"'
              @click="do_toggle_mute(data.item)">
              UNMUTED
            </b-button>
            <b-button-group v-if="data.item.present">
              <b-button
                class="btn_ctrl btn_kind" size="sm"
                :variant='(data.item.is_pres)?"warning":"outline-secondary"'
                @click="set_kind(data.item,'prs')">
                PANELIST
              </b-button>
              <b-button
                class="btn_ctrl btn_kind" size="sm"
                :disabled="(focus_uid == data.item.uid)"
                :variant='(data.item.is_mod)?"warning":"outline-secondary"'
                @click="set_kind(data.item,'mod')">
                VOICE
              </b-button>
              <b-button
                class="btn_ctrl btn_kind" size="sm"
                :variant='(data.item.is_qna)?"warning":"outline-secondary"'
                @click="set_kind(data.item,'inl')">
                HANDUP
              </b-button>
              <b-button
                class="btn_ctrl btn_kind" size="sm"
                :variant='(data.item.is_aud)?"warning":"outline-secondary"'
                @click="set_kind(data.item,'aud')">
                AUD
              </b-button>
            </b-button-group>
            <b-button  v-if="data.item.fixed && !data.item.present"
              class="btn_ctrl" size="sm"
              variant="outline-secondary">
              PANELIST NOT HERE
            </b-button>
            <b-button  v-if="data.item.pinned && !data.item.present"
              class="btn_ctrl" size="sm"
              variant="outline-secondary">
              PINNED USER NOT HERE
            </b-button>
            <b-button  v-if="data.item.present"
              class="btn_ctrl" size="sm"
              :disabled='data.item.pos > selected_layout_cnt || data.item.is_mod'
              :variant='(focus_uid == data.item.uid)?"warning":"outline-secondary"'
              @click="do_focus(data.item)">
              FOCUS
            </b-button>
          </template>
          <template v-slot:cell(dname)="data">
            {{ data.item.dname }}
          </template>
          <template v-slot:cell(uid)="data">
            <b-button v-if="data.item.fixed && !data.item.present"
              class="btn_ctrl" size="sm" style="float:right"
              variant="danger" @click="removePresenter(data.item)">
              Remove
            </b-button>
            <b-button v-if="data.item.present && !eject_uid && !data.item.is_pres && !data.item.is_mod"
              class="btn_ctrl" size="sm" style="float:right"
              variant="danger" @click="do_eject(data.item)">
              Eject
            </b-button>
            <b-button v-if="data.item.present && eject_uid == data.item.uid"
              class="btn_ctrl" size="sm" style="float:right"
              variant="danger" @click="do_eject(data.item)">
              Confirm Eject
            </b-button>
            <b-button v-if="data.item.pos > 0 && data.item.is_pres && layout.has_big"
              class="btn_ctrl" size="sm" style="float:right"
              variant="primary" @click="do_to_front(data.item)">
              To Big
            </b-button>
          </template>
        </b-table>
    </b-row>
    <b-row style="border-top: 2px solid; padding: 0.5rem 0;">
    </b-row>
  </div>
  </b-container>
</template>

<script>
  import { sync } from "vuex-pathify";
  import store from "../store";
  import vx_api from "../vuemix";
  import { format, getUnixTime } from 'date-fns';
  import { CSV } from '../csv.js'

  export default {
  name: "truck",
  data() {
    return {
      addlistener: true,
      eject_uid: null,
      focus_pos: -1,
      focus_uid: null,
      num_panelists: 1,
      is_locked: false,
      current_time: "",
      saveFile: null,
      saveFileName: "",
      ly_qna:"2x1p5",
      ly_qna_txt:"2",
      selected_layout: "",
      selected_layout_cnt: 0,
      selected_ac: null,
      prsonly: false,
      layout: {},
      loadFile: null,
      input: {
        email:"",
      },
      filtered: false,
      filt: {
        name:"",
      },
      meeting: {
        name: "-",
        msg: "-",
        start_ep: 0,
      },
      presenters:[],
      qna:[],
      qna_cnt: 0,
      pres_cnt: 0,
      qnaFields:[
          { key: "pin", label: "", class:"cls_pin"},
          { key: "pos", label: "", class:"cls_pos"},
          { key: "visible", label: "", class:"cls_visible"},
          { key: "dname", label: ""},
          { key: "uid", label: ""},
      ],
      owner: {},
    };
  },
  components: {
  },
  created() {
  },
  mounted() {
    let vue=this;
    vue.init_page();
    window.clearTimeout(vue.time_tid);
    vue.time_tid = setInterval(function() {
      vue.current_time = format(Date.now(),'E h:mm:ss a');
      vue.updateMeeting();
      if (vue.pres_p) {
         let delta = (Date.now() - vue.pres_p.start_ep)/1000;
         let min = (delta/60).toFixed(0);
         let sec = (delta % 60).toFixed(0);
         if (sec.length < 2) { sec = "0"+sec; }
         vue.pres_p.timer = min+":"+sec;
      }
    }, 1000);
    window.clearTimeout(vue.refr_tid);
    vue.refr_tid = setInterval(function() {
      vue.refreshAll();
    }, 120000);
  },
  beforeDestroy() {
    let vue=this;
    window.wss_clr_routes(window.vx,"hall");
    document.removeEventListener("keydown", vue.handle_keypress);
    vue.addlistener = true;
    window.clearTimeout(vue.time_tid);
    window.clearTimeout(vue.refr_tid);
  },
  methods: {
     updateMeeting: function() {
       let vue = this;
       let m = vue.meeting;
       let now = Date.now()/1000;
       if (m.start_ep <= 1000) {
         m.start_ep += 1;
         if (m.start_ep == 30) {
             wss_send(vx, "get_meetings", {tgt_em:"_anchor_",for_tm:"curhour"});
             m.start_ep = 0;
         }
       } else if (m.start_ep <= (now+2)) {
          if (m.end_ep >= now+60) {
            let left = ((59 + m.end_ep - now)/60).toFixed(0);
            vue.meeting.msg = ""+left+" min left";
          } else {
            let left = ((m.end_ep - now)).toFixed(0);
            vue.meeting.msg = ""+left+" sec left";
          }
          if (m.end_ep <= (now+1)) {
             vue.meeting.name = "-";
             vue.meeting.msg = "";
             vue.meeting.acnt = 0;
             vue.meeting.start_ep = 27;
             vue.meeting.end_ep = 0;
          }
       } else if (m.start_ep > (now+60)) {
          let unt = ((59 + m.start_ep - now)/60).toFixed(0);
          vue.meeting.msg = "starts in "+unt+"min";
       } else {
          let unt = ((m.start_ep - now)).toFixed(0);
          vue.meeting.msg = "starts in "+unt+"sec";
       }
     },
     toggleLock: function() {
       this.is_locked = !this.is_locked;
     },
     enableSave: function() {
       let vue = this;
       if (vue.saveFile) { return false; }
       if (vue.loadFile) { return false; }
       if (!vue.saveFileName) { return false; }
       return true;
     },
     refreshSelf: function() {
       vx_api.getSelf(window.vx);
     },
     refreshList: function() {
       this.do_list_room();
     },
     refreshAll: function() {
       this.refreshSelf();
       this.refreshList();
     },
     get_layout_cnt: function(ly)  {
       if (ly == "1x1p5") {
          return 1;
       } else if (ly == "2x1p5") {
          return 2;
       } else if (ly == "2x2p5") {
          return 4;
       } else if (ly == "3x2p5") {
          return 6;
       } else if (ly == "3x3p5") {
          return 9;
       } else if (ly == "4x3p5") {
          return 12;
       } else if (ly == "4x4p5") {
          return 16;
       } else if (ly == "1on4") {
          return 5;
       } else if (ly == "2on4") {
          return 6;
       }
       return -1;
     },
     config_layout: function(ly) {
       let vue = this;
       let parts = ly.split(".");
       ly = parts[0];
       vue.layout = {};
       vue.layout.skip = (0|parts[1]) || 0;
       vue.layout.cnt = vue.get_layout_cnt(ly);
       vue.layout.has_big = false;
       if (ly == "1on4" || ly == "2on4") {
          vue.layout.has_big = true;
       }
       vue.layout.start = vue.layout.skip;
       vue.layout.end = vue.layout.skip + vue.layout.cnt;
        console.log("LAYOUT "+vue.layout.start+" "+vue.layout.end);
     },
     compute_va: function() {
       let vue = this;
       let found_first_qna = false;
       vue.qna.forEach(function(p) {
          if (!p.present) { return; }
          p.visible = false;
          if (!vue.prsonly || p.is_pres) {
            if (vue.layout && p.pos >= vue.layout.start &&
                p.pos < vue.layout.end) {
              p.visible = true;
            }
          }

          p.audible = false;
          if (!p.muted) {
            if (p.is_pres || p.is_mod) {
              p.audible = true;
            }
            if (vue.selected_ac == 1 && p.visible) {
              if (!found_first_qna && p.is_qna) {
                 found_first_qna = true;
                 p.audible = true;
              }
            }
          }
       });
     },
     update_storage: function() {
       let vue = this;
       let x = {};
       x.presenters = vue.presenters;
       x.selected_layout = vue.selected_layout;
       x.selected_layout_cnt = vue.selected_layout_cnt;
       x.focus_pos = vue.focus_pos;
       x.focus_uid = vue.focus_uid;
       window.setLocal("truck",JSON.stringify(x));
     },
     pull_storage: function() {
       let vue = this;
       try {
          let x = JSON.parse(window.getLocal("truck"));
          vue.presenters = x.presenters;
          vue.selected_layout = x.selected_layout;
          vue.selected_layout_cnt = x.selected_layout_cnt;
          vue.focus_pos = x.focus_pos;
          vue.focus_uid = x.focus_uid;
       } catch (e) {
       }
     },
     init_page() {
       let vue = this;
       vue.pull_storage();
       window.vx_set_room(vx,
          vue.$router.currentRoute.params.acc,
          vue.$router.currentRoute.params.uid,
          "truck");
       window.wss_open(vx, {
         acc: vx.room.acc,
         room: vx.room.name,
         uid: vx.user.id,
         routes_id: "truck",
         routes: {
           auth_me: function(msg) {
             if (vx.acc == vx.room.acc && vx.room.name == vx.user.my_room_name) {
               wss_send(vx, "auth_room", {"cred":vx.user.creds["myroom"]});
             } else {
               wss_send(vx, "auth_room", {});
             }
           },
           auth_room: function() {
             vue.do_list_room();
             wss_send(vx, "get_room_ctrl", {});
             wss_send(vx, "get_meetings", {tgt_em:"_anchor_",for_tm:"curhour"});
             wss_send(vx, "cfg_remote", {set_conn:{disabled: true}});
           },
           room: function(msg) {
             vue.do_list_room();
             vue.handle_user_exit(msg.data);
           },
           room_ctrl: function(msg) {
             if (!msg || !msg.data || !msg.data.state) { return; }
             vue.config_layout(msg.data.state.pl);
             vue.compute_va();
             if (vue.layout.cnt > 1) {
               vue.selected_layout = msg.data.state.pl;
               vue.selected_layout_cnt = vue.layout.cnt;
             }
             vue.selected_ac = msg.data.state.ac;
             vue.prsonly = msg.data.prsonly || false;
             /* Verify current setting is valid for these controls */
             if (vue.layout.cnt < 0 ||
                 (vue.selected_ac != 0 &&
                  vue.selected_ac != 1)) {
                vue.selected_layout = "2x2p5";
                vue.selected_ac = 0;
                vue.focus_pos = -1;
                vue.focus_uid = null;
                vue.change_layout();
             }
           },
           list_room: vue.handle_list_room,
           list_user: vue.handle_list_user,
           raise_hand: function(msg) { console.log(msg); },
           get_meetings: function(msg) {
             if (!wss_ishash(msg)) { return; }
             let m = msg.data[0];
             if (!m) { return; }
             vue.meeting.start_ep = m.start_ep;
             vue.meeting.end_ep = m.end_ep;
             vue.meeting.acnt = m.regcnt;
             vue.meeting.name = m.name;
             vue.updateMeeting();
           }
         },
       });
       if (vue.addlistener) {
         document.addEventListener("keydown", vue.handle_keypress);
         vue.addlistener = false;
       }
       vue.handle_list_room();
     },
     handle_new_join: function(data) {
       if (data.k != "user_joined") { return; }
     },
     handle_user_exit: function(data) {
       let vue = this;
       if (data.k != "user_exited") { return; }
       let uid = data.uid;
       let p = vue.getPresenterByUID(uid);
       if (!p) { return; }
       if (vue.pres_p && vue.pres_p.state.uid == uid) {
          vue.pres_p = null;
       }
       delete p.kind;
       p.is_pres = false;
       p.present = false;
     },
     handle_keypress: function(et) {
       let vue = this;
       if (et.isComposing || et.keyCode === 229) {
         return;
       }
     },
     do_lower_hand_all: function() {
       let vue = this;
       vue.pres_p = null;
       window.wss_send(vx, "lower_hand", {tgt_uid: "all"});
     },
     do_toggle_hand: function(u) {
       let vue = this;
       if (u.is_pres) { return; }
       if (u.is_qna) {
         window.wss_send(vx, "lower_hand", {tgt_uid: u.uid});
       } else {
         window.wss_send(vx, "raise_hand", {tgt_uid: u.uid});
       }
     },
     do_toggle_mute: function(u) {
       let vue = this;
       if (u.muted) {
         let up = {};
         console.log("unmute");
         up.tgt_uid = u.uid;
         up.state = {blk:0};
         wss_send(vx, "update_user_state", up);
       } else {
         let up = {};
         console.log("mute");
         up.tgt_uid = u.uid;
         up.state = {blk:1};
         wss_send(vx, "update_user_state", up);
       }
     },
     set_kind: function(u, kind) {
       let vue = this;
       if (kind == "prs") {
         if (u.is_pres) { return; }
         window.wss_send(vx, "raise_hand", {tgt_uid: u.uid, tgt_to:"prs"});
       } else if (kind == "mod") {
         if (u.is_mod) { return; }
         vue.removePresenter_internal(u);
         window.wss_send(vx, "raise_hand", {tgt_uid: u.uid, tgt_to:"mod"});
       } else if (kind == "inl") {
         if (u.is_qna) { return; }
         vue.removePresenter_internal(u);
         window.wss_send(vx, "raise_hand", {tgt_uid: u.uid, tgt_to:"inl"});
       } else if (kind == "aud") {
         if (u.is_aud) { return; }
         vue.removePresenter_internal(u);
         window.wss_send(vx, "lower_hand", {tgt_uid: u.uid});
       }
     },
     do_toggle_panelist: function(u) {
       let vue = this;
       if (!u.is_pres) {
         window.wss_send(vx, "raise_hand",
             {tgt_uid: u.uid, tgt_to:"prs"});
       } else {
         vue.removePresenter_internal(u);
         window.wss_send(vx, "lower_hand",
             {tgt_uid: u.uid});
       }
     },
     do_to_front: function(u) {
       let vue = this;
       if (u.is_pres) {
         window.wss_send(vx, "raise_hand",
             {tgt_uid: u.uid, tgt_to:"prs"});
       }
     },
     do_eject: function(u) {
       let vue = this;
       if (!vue.eject_uid) {
         vue.eject_uid = u.uid;
         setTimeout(function() {
            vue.eject_uid = null;
         }, 3000);
       } else if (u.uid == vue.eject_uid) {
         window.wss_send(vx, "exit_room", {tgt_uid: u.uid, blklist:true});
       }
     },
     do_focus: function(u) {
       let vue = this;
       if (vue.focus_uid == u.uid) {
         vue.focus_pos = -1;
         vue.focus_uid = null;
         vue.change_layout();
       } else {
         vue.focus_pos = u.pos;
         vue.focus_uid = u.uid;
         vue.change_layout();
       }
       vue.update_storage();
     },
     do_host_unmute: function() {
       let vue = this;
       if (!vue.owner.muted) { return; }
       let up = {};
       up.tgt_uid = vue.owner.uid;
       up.state = {blk:0};
       wss_send(vx, "update_user_state", up);
     },
     do_host_mute: function() {
       let vue = this;
       if (vue.owner.muted) { return; }
       let up = {};
       up.tgt_uid = vue.owner.uid;
       up.state = {blk:1};
       wss_send(vx, "update_user_state", up);
     },
     do_host_raise: function() {
       let vue = this;
       vue.do_host_unmute();
       window.wss_send(vx, "raise_hand", {tgt_uid: vue.owner.uid, tgt_to:"prs"});
     },
     do_host_audioonly: function() {
       let vue = this;
       vue.do_host_unmute();
       window.wss_send(vx, "raise_hand", {tgt_uid: vue.owner.uid, tgt_to:"mod"});
     },
     do_make_pres: function(u) {
       let vue = this;
       vue.pres_p = u;
       u.start_ep = Date.now();
       window.wss_send(window.vx, "raise_hand", {tgt_uid: u.state.uid, tgt_to:"prs"});
     },
     do_list_room: function() {
       let vue = this;
       if (!vue.filt.name) {
          window.wss_send(window.vx, "list_room", {
             limit:30
          });
          vue.filtered = false;
       } else {
          console.log("list_room + filter");
          window.wss_send(window.vx, "list_room", {
             limit:30,
             start_idx: 0,
             aud_mode: true,
             filt: vue.filt,
          });
          vue.filtered = true;
       }
     },
     getPresenterByUID: function(uid) {
       let vue = this;
       for (let i=0; i<vue.presenters.length; i++) {
          let p = vue.presenters[i];
          if (p.uid == uid) {
             return p;
          }
       }
       return null;
     },
     extract_user(p, it) {
         if (it.kind) {
           p.present = true;
         }
         p.muted = false;
         p.self_muted = false;
         if ((it.ma&&it.ma.blk) || (it.sa&&it.sa.blk)) {
           p.muted = true;
         }
         if ((it.sa&&it.sa.blk)) {
           /* Don't set if "self" is user controlling panel */
           if (window.vx.user && window.vx.user.id != it.uid) {
             p.self_muted = true;
           }
         }
         if (it.dname) {
           p.dname = it.dname;
         }
         if (it.uid) {
           p.uid = it.uid;
         }
         if (it.kind) {
           p.is_pres = p.is_mod = p.is_qna = p.is_aud = false;
           if (it.kind == "prs") {
             p.is_pres = true;
           } else if (it.kind == "mod") {
             p.is_mod = true;
           } else if (it.kind == "inl") {
             p.is_qna = true;
           } else if (it.kind == "aud") {
             p.is_aud = true;
           }
         }
         p.visible = false;
     },
     handle_list_user: function(msg) {
       let vue = this;
       if (!wss_ishash(msg)) { return; }
       let it = msg.data;
       if (!it.kd) { delete it.kind; }
       vue.qna.forEach(function(p) {
          if (p.uid == it.uid) {
            vue.extract_user(p,it);
          }
       });
       vue.compute_va();
       vue.sort_and_render();
     },
     handle_list_room: function(msg) {
       let vue = this;
       console.log(msg);
       if (!wss_ishash(msg)) { return; }
       /* Clear presenter present */
       for (let x=0; x<vue.presenters.length; x++) {
         vue.presenters[x].present = false;
       }
       /* Rememeber pinned users */
       let pinned = {};
       vue.qna.forEach(function(p) {
          if (p.pinned) {
            pinned[p.uid] = p;
          }
       });
       /* Update list and mark presenters */
       vue.qna = [];
       vue.qna_cnt = 0;
       vue.pres_cnt = 0;
       for (let i=0; i<msg.data.length; i++) {
         let it = msg.data[i];
         let p = {};
         vue.extract_user(p,it);
         for (let x=0; x<vue.presenters.length; x++) {
            if (p.uid == vue.presenters[x].uid) {
              vue.presenters[x].present = true;
              p.em = vue.presenters[x].em;
              p.fixed = true;
              if (!p.is_pres) {
                 vue.set_kind(p,'prs');
              }
              break;
            }
         }
         p.pinned = (pinned[p.uid]) ? true : false;
         delete pinned[p.uid];
         vue.qna.push(p);
       }
       /* Record position */
       let pos = 0;
       let focus_found = false;
       for (let i=0; i<vue.qna.length; i++) {
         let p = vue.qna[i];
         /* Moderators never visible */
         if (p.is_mod) { continue; }
         if (p.is_qna) { vue.qna_cnt++; }
         if (p.is_pres) { vue.pres_cnt++; }
         if (p.uid == vue.focus_uid) { focus_found = true; }
         p.pos = pos;
         pos++;
       }
       console.log("focus_found",focus_found,vue.focus_uid);
       if (!focus_found) {
          /* Clear out focus if person is gone */
          vue.focus_pos = -1;
          vue.focus_uid = null;
          vue.change_layout();
       }
       /* Add in any not-found presenters */
       for (let x=0; x<vue.presenters.length; x++) {
         if (!vue.presenters[x].present) {
           vue.qna.unshift({fixed:true, em:vue.presenters[x].em,
                            dname:vue.presenters[x].em});
         }
       }
       /* Add in any not-found pinned users */
       Object.keys(pinned).forEach(function(uid) {
         vue.qna.push({uid: uid, pinned:true});
         window.wss_send(window.vx, "list_user", {tgt_uid: uid});
       });
       vue.compute_va();
       vue.sort_and_render();
     },
     sort_and_render: function() {
       let vue = this;
       vue.qna = vue.qna.sort(function(a,b) {
         if (a.pinned && !b.pinned) { return -1; }
         if (!a.pinned && b.pinned) { return 1; }
         return (a.pos - b.pos);
       });
     },
     array_move: function(arr, old_index, new_index) {
       if (new_index >= arr.length) {
           var k = new_index - arr.length + 1;
           while (k--) {
             arr.push(undefined);
           }
       }
       arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
       for (let i=0; i<arr.length; i++) {
         arr[i].idx = i;
       }
       return arr; // for testing
     },
     move_up: function(p) {
       let vue = this;
       let i = p.idx;
       //console.log("move_up:"+i);
       if (!i) { return; }
       vue.array_move(vue.presenters, i, i-1);
     },
     move_down: function(p) {
       let vue = this;
       let i = p.idx;
       //console.log("move_down:"+i);
       if (!i || i >= vue.presenters.length-1) { return; }
       vue.array_move(vue.presenters, i, i+1);
     },
     remove_presenter: function(p) {
       let vue = this;
       if (!i && i !== 0) { return; }
       vue.presenters.splice(p.idx, 1);
     },
     make_save_file: function() {
       let vue = this;
       let j = {fields:[{id:"email"}/*,{id:"uid"}*/],records:[]};
       let csv = new CSV;
       vue.presenters.forEach(function(p) {
         let jp = {};
         console.log(JSON.stringify(p));
         jp.email = p.em;
         //jp.uid = p.uid;
         j.records.push(jp);
       });
       let txt = csv.serialize(j);
       let data = new Blob([txt], {type: 'text/plain'});
       if (vue.saveFile !== null) {
         window.URL.revokeObjectURL(vue.saveFile);
       }
       vue.saveFile = window.URL.createObjectURL(data);

       let link = document.getElementById('downloadlink');
       link.href = vue.saveFile;
       link.style.display = 'block';
       link.download = ""+vue.saveFileName;
     },
     downloaded_file: function() {
       let vue = this;
       window.setTimeout(function() {
         let link = document.getElementById('downloadlink');
         link.href = null;
         link.style.display = 'none';
         if (vue.saveFile !== null) {
           window.URL.revokeObjectURL(vue.saveFile);
         }
         vue.saveFile = null;
       }, 2000);
     },
     load_from_file: function() {
       let vue = this;
       let reader = new FileReader();
       /* Clear out existing panelists */
       vue.presenters = [];
       vue.qna.forEach(function(p) {
          if (!p.is_pres) { return; }
          vue.set_kind(p,'aud');
       });
       reader.onload = function(e) {
         let contents = e.target.result;
         let csv = new CSV;
         let c = csv.parse(contents);
         let email_idx=0, uid_idx;
         c.r[0].forEach(function(v,idx) {
            if (v == "email") {
               email_idx=idx;
            } else if (v == "uid") {
               uid_idx=idx;
            }
         });
         c.r.forEach(function(row,rowidx) {
           if (rowidx == 0) { return; }
           vue.addPresenter_internal(row[email_idx]);
         });
         vue.loadFile = null;
         setTimeout(vue.refreshAll, 3000);
       }
       reader.readAsText(vue.loadFile);
     },
     change_layout: function() {
       let vue = this;
       let c = { set_ctrl: {state:{}} };
       if (!vue.focus_uid || vue.focus_pos < 0) {
         c.set_ctrl.state.pl = vue.selected_layout;
       } else {
         c.set_ctrl.state.pl = "1x1p5."+vue.focus_pos+"."+vue.focus_uid;
       }
       c.set_ctrl.state.al = "4x3a";

       /* Set audio mode */
       c.set_ctrl.state.ac = vue.selected_ac;
       c.set_ctrl.state.prv = false;
       c.set_ctrl.prsonly = vue.prsonly || false;

       window.wss_send(window.vx, "set_room_ctrl", c);
     },
     select_ac: function(ac) {
       let vue = this;
       if (vue.prsonly) {
          return;
       }
       vue.selected_ac = ac;
       vue.change_layout();
     },
     select_prsonly: function(p) {
       let vue = this;
       vue.prsonly = p;
       if (p) {
          // For clarity, if only hosts can be seen
          //   only hosts can be heard
          vue.selected_ac = 0; // Hosts Only Audio
       }
       vue.change_layout();
     },
     select_layout: function(nm) {
       let vue = this;
       vue.selected_layout = nm;
       vue.selected_layout_cnt = vue.get_layout_cnt(nm);
       vue.change_layout();
       vue.update_storage();
     },
     addPresenterKP: function(e) {
       if (this.is_locked) { return; }
       if (e.keyCode === 13) {
          this.addPresenter();
       }
     },
     searchPartKP: function(e) {
       if (e.keyCode === 13) {
          this.do_list_room();
       }
     },
     addPresenter: function() {
       let vue = this;
       let em = vue.input.email.toLowerCase();
       vue.addPresenter_internal(em, function() {
         vue.input.email = "";
       });
     },
     addPresenter_internal: function(em, cb) {
       let vue = this;
       if (!em) { return; }
       for (let x=0; x<vue.presenters.length; x++) {
         if (vue.presenters[x].em == em) {
            if (cb) { cb(); }
            return;
         }
       }
       vx_api
         .getUID(window.vx, { em: em })
         .then( res => {
             if (res.uid) {
                vue.presenters.push({uid:res.uid, em:em});
                vue.do_list_room();
                vue.update_storage();
                if (cb) { cb(); }
             }
          });
     },
     removePresenter: function(p) {
       let vue = this;
       vue.removePresenter_internal(p);
       vue.do_list_room();
     },
     removePresenter_internal: function(p) {
       let vue = this;
       vue.presenters = vue.presenters.filter(function(x) {
         if (x.em != p.em) return true;
       });
       vue.update_storage();
     },
     toggle_pin: function(p) {
       let vue = this;
       p.pinned = !p.pinned;
       vue.sort_and_render();
     }
  },
  computed: {
  },
};
</script>

<style lang="scss">
.container {
  position:relative;
  /*height:90vh;*/
  max-width:90vw;
  padding:0;
}
.btn_ctrl {
  margin: 0 0.5rem;
  padding:0.1rem;
  font-weight: 700;
  font-size: 0.7rem;
}
.btn_layout {
  padding: 0 5px;
}
.btn_kind {
  margin:0;
}
.cls_pin {
  width:0;
}
.cls_pos {
  width:2rem;
  padding-left:0 !important;
}
.cls_visible {
  width:30rem;
}
</style>
